/* File every enquiry-form submission on the shop, alongside the email Shopify
   already sends.

   The forms are {% form 'contact' %}: a real, native POST that navigates the
   browser away. That is what must keep working, so this never calls
   preventDefault and never blocks. It reads the fields, posts a copy to the
   enquiry service and lets the submit carry on.

   keepalive is the whole trick. The page is unloading a few milliseconds after
   submit, and an ordinary fetch is cancelled when it does -- which is why the
   obvious version of this appears to work locally and silently loses most
   submissions in the field. keepalive: true asks the browser to finish the
   request after the document is gone. Its body limit is 64 KB; an enquiry is
   a fraction of that.

   Everything here is wrapped so that a failure cannot take the form with it.
   A thrown error, a blocked request, a service that is down -- all of them end
   with the submission emailed and not filed, which is where these forms
   started. */
(function () {
  var CONFIG_SELECTOR = '[data-vp-enquiry]';

  /* The form's own fields, as the admin will read them. contact[...] is
     Shopify's naming; the brackets are stripped so the record says "Order
     Number", not "contact[Order Number]". */
  function readFields(form) {
    var out = {};
    var data = new FormData(form);
    data.forEach(function (value, name) {
      if (typeof value !== 'string') return;
      var key = name.replace(/^contact\[/, '').replace(/\]$/, '');
      if (!key || key === 'form_type' || key === 'utf8') return;
      /* A repeated name (a checkbox group) keeps the first and appends the
         rest rather than silently dropping them. */
      out[key] = key in out ? out[key] + ', ' + value : value;
    });
    return out;
  }

  function send(form, config) {
    var fields = readFields(form);

    /* The opt-in is read from the control, not from the serialised fields: an
       unticked checkbox is absent from FormData entirely, and "absent" has to
       mean false rather than undefined by the time the service sees it. */
    var box = form.querySelector('[data-vp-optin]');
    var optIn = Boolean(box && box.checked);

    var email = fields.email || fields.Email || '';
    var name = [fields['First Name'], fields['Last Name']].filter(Boolean).join(' ')
      || fields.Name || '';

    var payload = {
      form: config.formKey,
      ts: config.ts,
      sign: config.sign,
      email: email,
      name: name,
      phone: fields.Phone || '',
      subject: fields.Subject || '',
      message: fields.body || '',
      marketing_opt_in: optIn,
      page_url: window.location.href,
      fields: fields
    };

    var url = config.endpoint.replace(/\/+$/, '') + '/enquiries';
    try {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true,
        mode: 'cors',
        credentials: 'omit'
      }).catch(function () { /* emailed but not filed; the form still went */ });
    } catch (e) { /* same */ }
  }

  function bind(config) {
    if (!config) return;
    var settings = {
      endpoint: config.getAttribute('data-endpoint') || '',
      formKey: config.getAttribute('data-form-key') || '',
      ts: config.getAttribute('data-ts') || '',
      sign: config.getAttribute('data-sign') || ''
    };
    if (!settings.endpoint || !settings.formKey) return;

    /* The marker sits inside its own form, so each form gets its own key even
       though two of them live in one section. */
    var form = config.closest('form');
    if (!form || form.dataset.vpEnquiryBound) return;
    form.dataset.vpEnquiryBound = '1';

    form.addEventListener('submit', function () {
      /* No preventDefault: the native POST is what emails the house, and it
         is not ours to delay. Browser validation runs before this fires, so
         an invalid form never reaches here. */
      try { send(form, settings); } catch (e) { /* never block the submit */ }
      try { announce(form, settings); } catch (e) { /* analytics never blocks */ }
    });
  }

  /* Tell the analytics layer an enquiry happened.
   *
   *  Shopify's Google channel sends the shop's standard commerce events and
   *  nothing else, so an enquiry -- the highest-intent thing anyone does on a
   *  jewellery site short of buying -- is invisible in GA4. A custom pixel
   *  cannot see this form either: pixels run in their own sandbox with no
   *  access to the page. publish() is the bridge Shopify provides between the
   *  two, so the theme announces it and the pixel forwards it to GA4.
   *
   *  No address is published. The pixel is a sandbox, but the event still
   *  reaches Google, and who enquired is the shop's business, not Google's --
   *  the Worker already files the identity on the shop. Only which form, and
   *  whether the mailing-list box was ticked, go out.
   */
  function announce(form, settings) {
    var a = window.Shopify && window.Shopify.analytics;
    if (!a || typeof a.publish !== 'function') return;
    var optIn = form.querySelector('[data-vp-optin]');
    a.publish('vp_enquiry_submitted', {
      form: settings.formKey,
      marketing_opt_in: !!(optIn && optIn.checked),
      page_url: location.pathname
    });
  }

  function boot(root) {
    var scope = root || document;
    Array.prototype.forEach.call(scope.querySelectorAll(CONFIG_SELECTOR), bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
